import { c as _c } from "react/compiler-runtime";
import { Icon } from "@/components/common/icon";
import { Card } from "../ui/card";
import { Text } from "../ui/text";
import { getSystemIcon } from "@/lib/system-lucide-icon-map";
import { Suspense } from "react";
export type ServiceProcessCardProps = {
  icon: string;
  text: string;
  stepNumber?: number;
  isLast?: boolean;
};
export const ServiceProcessCard = t0 => {
  const $ = _c(27);
  const {
    icon,
    text,
    stepNumber,
    isLast: t1
  } = t0;
  const isLast = t1 === undefined ? false : t1;
  if (stepNumber === undefined) {
    let t2;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
      t2 = <div className="bg-primary/5 text-primary flex h-12 w-12 shrink-0 items-center justify-center rounded-xl shadow-inner">icon</div>;
      $[0] = t2;
    } else {
      t2 = $[0];
    }
    let t3;
    if ($[1] !== text) {
      t3 = <div className="hover:border-primary/15 flex items-start gap-4 rounded-2xl border border-slate-100 bg-white p-5 shadow-sm transition-all duration-300 hover:shadow-md">{t2}<div className="flex-1"><Text className="text-sm leading-relaxed font-medium text-slate-700">{text}</Text></div></div>;
      $[1] = text;
      $[2] = t3;
    } else {
      t3 = $[2];
    }
    return t3;
  }
  const t2 = String(stepNumber);
  let t3;
  if ($[3] !== t2) {
    t3 = t2.padStart(2, "0");
    $[3] = t2;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== t3) {
    t4 = <div className="border-border bg-card text-muted-foreground group-hover:border-secondary group-hover:text-secondary z-10 flex h-10 w-10 items-center justify-center rounded-full border-2 text-sm font-bold shadow-sm transition-all duration-300 group-hover:scale-110">{t3}</div>;
    $[5] = t3;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== isLast) {
    t5 = !isLast && <div className="border-border group-hover:border-secondary/40 w-0 flex-1 border-l-2 border-dashed transition-colors duration-300" />;
    $[7] = isLast;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <div className="bg-border group-hover:bg-secondary/40 absolute top-5 left-10 z-0 h-0.5 w-6 transition-colors duration-300" />;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] !== t4 || $[11] !== t5) {
    t7 = <div className="relative flex shrink-0 flex-col items-center">{t4}{t5}{t6}</div>;
    $[10] = t4;
    $[11] = t5;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  const t8 = `bg-card group-hover:border-primary/20 relative flex flex-1 flex-row items-start gap-4 self-start overflow-hidden rounded-2xl p-5 shadow-sm transition-all duration-300 group-hover:shadow-md ${!isLast ? "mb-6 md:mb-0" : ""}`;
  let t9;
  if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <div className="bg-primary/5 pointer-events-none absolute -right-6 -bottom-6 h-24 w-24 rounded-full opacity-0 blur-2xl transition-opacity duration-500 group-hover:opacity-100" />;
    $[13] = t9;
  } else {
    t9 = $[13];
  }
  const t10 = icon as string;
  let t11;
  if ($[14] !== t10) {
    t11 = getSystemIcon(t10);
    $[14] = t10;
    $[15] = t11;
  } else {
    t11 = $[15];
  }
  let t12;
  if ($[16] !== t11) {
    t12 = <div className="bg-primary/5 text-primary group-hover:bg-primary flex h-12 w-12 shrink-0 items-center justify-center rounded-xl shadow-inner transition-all duration-300 group-hover:text-white"><Suspense><Icon name={t11} className="size-6" /></Suspense></div>;
    $[16] = t11;
    $[17] = t12;
  } else {
    t12 = $[17];
  }
  let t13;
  if ($[18] !== text) {
    t13 = <div className="flex-1 pt-1"><Text className="text-sm leading-relaxed font-medium">{text}</Text></div>;
    $[18] = text;
    $[19] = t13;
  } else {
    t13 = $[19];
  }
  let t14;
  if ($[20] !== t12 || $[21] !== t13 || $[22] !== t8) {
    t14 = <Card className={t8}>{t9}{t12}{t13}</Card>;
    $[20] = t12;
    $[21] = t13;
    $[22] = t8;
    $[23] = t14;
  } else {
    t14 = $[23];
  }
  let t15;
  if ($[24] !== t14 || $[25] !== t7) {
    t15 = <div className="group relative flex gap-6 md:flex-1">{t7}{t14}</div>;
    $[24] = t14;
    $[25] = t7;
    $[26] = t15;
  } else {
    t15 = $[26];
  }
  return t15;
};